<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div v-if="quizData.quizSettings && quizData.quizSettings.quizType == 'graded'" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Assessor Final Score: </p>
        <p>{{ totalScore + " / " +  quizData.quizSettings.maxScore}}</p>
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Assessor Final Comment:</label>
        <vs-textarea readOnly v-model="quizData.finalAssessorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Moderator Final Comment:</label>
        <vs-textarea readOnly v-model="quizData.finalModeratorComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Evaluator Comment:</label>
        <vs-textarea v-model="quizData.finalEvaluatorComment" />
      </div>
      <div class="vx-col sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Predefined Comments:</label>
        <v-select placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      totalScore: {
        type: Number,
        required: false
      },
      quizData: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        predCommentDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    methods: {
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.quizData.finalEvaluatorComment == null){
            self.quizData.finalEvaluatorComment = "";
          }
          self.quizData.finalEvaluatorComment += self.predCommentDropdown.label + " ";
        }
      },
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
